module.exports = __webpack_public_path__ + "static/media/tab_menu_img.fdf59e98.png";